/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function DeleteIcon(props: CustomSvgIcon) {
    const {
        id,
        className,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id || ''}
            onClick={onClick}
        >
            <svg xmlns='http://www.w3.org/2000/svg'>
                <g>
                    <title>Layer 1</title>
                    <g
                        id='Layer_2'
                        stroke='null'
                    >
                        <g
                            fill={iconColor || '#000000'}
                            id='Layer_1-2'
                            stroke='null'
                        >
                            <path
                                d='m7.495877,23.598322a4.119243,3.438747 0 0 1 -3.989582,-3.480378l-0.658281,-14.987275l0.997395,0l0.658281,14.987275a3.121848,2.606121 0 0 0 2.992186,2.672731l8.906741,0a3.161744,2.639426 0 0 0 2.992186,-2.664404l0.668255,-14.987275l0.997395,0l-0.668255,14.987275a4.179087,3.488705 0 0 1 -3.989582,3.480378l-8.906741,0l0,-0.008326zm9.854267,-19.092123l-0.997395,0l0,-1.78182a2.114478,1.765168 0 0 0 -0.518646,-1.165677a1.615781,1.348855 0 0 0 -1.196875,-0.499576l-5.326092,0a1.845182,1.540359 0 0 0 -1.71552,1.665253l0,1.78182l-0.997395,0l0,-1.78182a2.852551,2.381311 0 0 1 2.712916,-2.497879l5.326092,0a2.613176,2.181481 0 0 1 1.934947,0.741037a2.992186,2.497879 0 0 1 0.777968,1.756842l0,1.78182z'
                                id='svg_1'
                                stroke='null'
                            />
                            <path
                                d='m22.307199,5.1723l-20.676008,0a0.508672,0.424639 0 0 1 -0.498698,-0.424639a0.498698,0.416313 0 0 1 0.498698,-0.416313l20.676008,0a0.498698,0.416313 0 0 1 0.508672,0.416313a0.508672,0.424639 0 0 1 -0.508672,0.424639z'
                                id='svg_2'
                                stroke='null'
                            />
                        </g>
                    </g>
                </g>
            </svg>
        </SvgIcon>
    );
}